export default __webpack_public_path__ + "static/media/shopee.691ac902.png";